<template>
  <div class="change-password-container">
    <div class="change-password-header">
      修改密码
    </div>
    <div class="change-password-content">
      <el-form ref="passwordFormRef"
               :model="passwordForm"
               :rules="passwordFormRules"
               label-width="100px">
        <el-form-item label="原密码"
                      prop="oldPassword">
          <el-input v-model="passwordForm.oldPassword"
                    clearable
                    size="mini"></el-input>
        </el-form-item>
        <el-form-item label="新密码"
                      prop="newPassword">
          <el-input v-model="passwordForm.newPassword"
                    clearable
                    size="mini"></el-input>
        </el-form-item>
        <el-form-item label="重复新密码"
                      prop="comfirmPassword">
          <el-input v-model="passwordForm.comfirmPassword"
                    clearable
                    size="mini"></el-input>
        </el-form-item>
      </el-form>
      <el-button type="primary"
                 size="mini"
                 @click="submitPasswordForm">保存</el-button>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入新密码'));
      } else {
        if (this.passwordForm.comfirmPassword !== '') {
          this.$refs.passwordFormRef.validateField('comfirmPassword');
        }
        callback();
      }
    };
    var validateConfirmPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请确认密码'));
      } else if (value !== this.passwordForm.newPassword) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      passwordForm: {
        oldPassword: '',
        newPassword: '',
        comfirmPassword: ''
      },
      passwordFormRules: {
        oldPassword: [
          { required: true, message: '请输入旧密码', trigger: 'blur' },
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/, message: '密码必须包含数字和字母，且在8-16位', trigger: 'blur' },
          { validator: validatePass, trigger: 'blur' }
        ],
        comfirmPassword: [
          { required: true, message: '请确认密码', trigger: 'blur' },
          { pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/, message: '密码必须包含数字和字母，且在8-16位', trigger: 'blur' },
          { validator: validateConfirmPass, trigger: 'blur' }
        ]
      }
    };
  },
  beforeCreate () {
    this.$store.commit('setActiveIndex', '/account')
    this.$store.commit('setSubActiveIndex', '/account/security')
    this.$store.commit('setAsideWidth', 300)
  },
  created () { },
  methods: {
    submitPasswordForm () {
      this.$refs.passwordFormRef.validate(valid => {
        if (valid) {
          this.$http.post('/api/services/app/account/ChangePassword', this.passwordForm)
            .then(res => {
              this.$message.success('密码修改成功！')
              this.$router.go(-1)
            })
            .catch(err => {
              this.$message.error(err.data.error.message)
            })
        } else {
          this.$message.error('表单提交失败！')
        }
      })

    }
  },
};
</script>
<style lang="less" scoped>
.change-password-container {
  width: 100%;
  min-width: 1200px;
  font-family: 'Source Han Sans CN';
  background-color: #fff;
  padding: 20px;
}
.change-password-header {
  border-bottom: 1px solid #eff2f9;
  display: flex;
  align-items: center;
  font-size: 16px;
  padding-bottom: 15px;
  color: #2f343c;
  font-weight: 600;
}
.change-password-content {
  margin-top: 40px;
}
.el-form-item {
  /deep/ .el-form-item__label {
    line-height: 28px;
  }
  /deep/ .el-form-item__content {
    display: flex;
    align-items: center;
  }
}
.el-input {
  width: 200px;
}
.el-button {
  margin-left: 90px;
}
</style>